import { useCallback, useEffect, useState } from 'react';
import { DEFAULT_CURRENCY, getActiveCurrency, setActiveCurrency } from '../utils/currency';

/**
 * Moneda del reporte que se está viendo. Al elegirla se fija como moneda activa (la usan formatMoney y los
 * servicios de reportes) y al salir de la pantalla vuelve a UYU para no afectar al resto del sistema.
 */
export default function useReportCurrency() {
  const [currency, setCurrencyState] = useState(getActiveCurrency());

  const setCurrency = useCallback((code) => {
    setActiveCurrency(code);
    setCurrencyState(getActiveCurrency());
  }, []);

  useEffect(() => () => setActiveCurrency(DEFAULT_CURRENCY), []);

  return [currency, setCurrency];
}
